import { equals2 } from "fxjs/es";
export const unselectCopyDestination = (self, id) => {
  if (self._copy_source_grid_id == null) {
    throw new Error(`먼저 복사를 시작해주세요.`);
  }
  const copy_destination_selected_grid_layer_el =
    self._getCopyDestinationSelectedGridLayerElThrowable();
  const copy_destination_unselected_empty_grid_layer_el =
    self._getCopyDestinationUnselectedEmptyGridLayerElThrowable();
  const copy_destination_unselected_existing_grid_layer_el =
    self._getCopyDestinationUnselectedExistingGridLayerElThrowable();
  if (equals2(id)(self._copy_source_grid_id)) {
    throw new Error("복사 대상이 아닙니다.");
  }
  const grid = self._grids.get(id);
  if (grid == null) {
    throw new Error(`해당 아이디의 그리드를 찾을 수 없습니다.`);
  }
  const {
    target_image_el,
    copy_destination_selected_grid_el,
    copy_destination_unselected_empty_grid_el,
    copy_destination_unselected_existing_grid_el,
  } = grid;
  if (
    !copy_destination_selected_grid_layer_el.contains(
      copy_destination_selected_grid_el
    )
  ) {
    return;
  }
  copy_destination_selected_grid_layer_el.removeChild(
    copy_destination_selected_grid_el
  );
  if (target_image_el == null) {
    copy_destination_unselected_empty_grid_layer_el.appendChild(
      copy_destination_unselected_empty_grid_el
    );
  } else {
    copy_destination_unselected_existing_grid_layer_el.appendChild(
      copy_destination_unselected_existing_grid_el
    );
  }
};
